export default __webpack_public_path__ + "static/media/incineracion.a8c9724c.svg";